<template>
  <div style="min-width: 80%">
    <h1 class="grey--text text--darken-2">Активности</h1>

    <v-row class="mt-3 mb-3">
      <v-col>
        <v-btn small color="blue" dark @click="createAction">
          <v-icon left dark>mdi-plus-circle-outline</v-icon> Создать
        </v-btn>
        <v-btn small color="yellow" @click="refreshAction" class="ml-3">
          <v-icon left dark>mdi-refresh</v-icon> Обновить
        </v-btn>
      </v-col>
      <v-col cols="3">
        <v-autocomplete v-model="filters.activityStatus" :items="filtersData.activityStatus" hide-no-data hide-details class="ma-0 pa-0"/>
      </v-col>
    </v-row>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Поиск"
        single-line
        hide-details
        class="mb-3">
      </v-text-field>

    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :search="search"
      :loading="loading"
      v-model="selectedItems"
      item-key="actitivyID"
      no-data-text="Активности отсутствуют"
      :items-per-page="20"
      dense
      class="elevation-1">
      <template #item.activityYear="{ item }">
        <router-link :to="'/activities/'+item.activityID" class="editable">{{ item.activityYear }}</router-link>
      </template>
      <template #item.companyName="{ item }">
        <router-link :to="'/activities/'+item.activityID" class="editable">
          {{ item.companyName }}
          <span v-if="item.client_company_id" class="font-weight-light blue-grey--text">({{ item.clientName }})</span>
        </router-link>
      </template>
      <template #item.activityStatus="{ item }">
        <v-chip v-if="statuses[item.activityStatus]" :color="statuses[item.activityStatus][0]" x-small dark>{{ statuses[item.activityStatus][1] }}</v-chip>
      </template>
      <template #item.activityBalance="{ item }">
        <span :class="item.activityBalance < 0 ? 'red--text' : 'green--text text--darken-1'">{{ item.activityBalance*1 }}</span>
      </template>
      <template #item.activityDtInvoice="{ item }">
        <span class="caption">{{ item.activityDtInvoice === null ? '&mdash;' : item.activityDtInvoice.substring(0, 10) }}</span>
      </template>
      <template #item.activity_dt_income="{ item }">
        <span class="caption">{{ item.activity_dt_income === null ? '&mdash;' : item.activity_dt_income.substring(0, 10) }}</span>
      </template>
    </v-data-table>

    <ActivitiesCreateDialog ref="activitiesCreateDialog" :companies="companies" @updated="load()"/>
  </div>
</template>

<script>
import api from '@/api'
import ActivitiesCreateDialog from '@/components/ActivitiesCreateDialog.vue'
import { activityStatuses } from '@/common'

export default {
  components: { ActivitiesCreateDialog },
  data: () => ({
    search: '',
    loading: false,
    selectedItems: [],
    headers: [
      {
        text: 'Год',
        value: 'activityYear',
        align: 'center',
        width: '60px',
        filterable: false,
      },
      {
        text: 'Статус',
        value: 'activityStatus',
        align: 'center',
        width: '100px',
        sortable: false,
        filterable: false,
      },
      {
        text: 'Компания',
        value: 'companyName',
      },
      {
        text: 'Контрагент DA',
        value: 'daName',
        sortable: false,
        width: '140px'
      },
      {
        text: 'Баланс',
        value: 'activityBalance',
        align: 'right',
        sortable: false,
        filterable: false,
      },
      {
        text: 'Списание',
        value: 'activityDtInvoice',
        align: 'center',
        width: '110px',
        filterable: false,
      },
      {
        text: 'Приход',
        value: 'activity_dt_income',
        align: 'center',
        width: '110px',
        filterable: false,
      },
      {
        text: 'Брендов',
        value: 'qntBrands',
        align: 'center',
        width: '50px',
        filterable: false,
        sortable: false
      }

    ],
    items: [],
    filters: { activityStatus: '' },
    // filtersData: {
    //   { value: '', text: 'Актуальные', },
    //   { value: '+', text: 'Все' },
    // },
    companies: [],
    statuses: activityStatuses
  }),
  computed: {
    filteredItems () {
      const filters = Object.assign({}, this.filters)
      if ( filters.activityStatus == '' ) filters.activityStatus = ['draft', 'pending', 'confirmed']
      if ( filters.activityStatus == '+' ) filters.activityStatus = []
      return this.items.filter(d => {
        return Object.keys(filters).every(f => {
          return 'undefined' === typeof d[f] || filters[f].length < 1 || (filters[f] instanceof Array ? filters[f].includes(d[f]) : filters[f] == d[f])
        })
      })
    },
    filtersData () {
      let filter_status = [
        { value: '', text: 'Актуальные', },
        { value: '+', text: 'Все' },
      ]
      for (const key in activityStatuses) filter_status.push({value: key, text: activityStatuses[key][1]})
      return { activityStatus: filter_status }
    }
  },
  mounted: function () {
    this.load()
  },
  methods: {
    load () {
      this.selectedItems = []
      this.loading = true;
      api.get('activities/list').then(response => {
        this.loading = false;
        if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.items = response.data.data.activities
//        this.items = response.data.data.items.map(val => Object.assign({}, val));
        this.companies = response.data.data.companies
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    refreshAction () {
      this.load()
    },
    createAction () {
      this.$refs.activitiesCreateDialog.create()
    },
  }
}
</script>

<style>
.v-application a { color: inherit; text-decoration: none }
.editable:hover { color: #08A2B8 !important; border-bottom: 1px #08A2B8 dashed; }
.v-list-item { min-height: 30px !important }
.v-list-item__content { padding: 7px 0; }
</style>
